import React, { useEffect } from 'react';

export default () => {
    const accessLink = 'https://bhp.service-now.com/sp?id=bhp_home';

    useEffect(() => {
        sessionStorage.clear();
        localStorage.clear();
    }, []);

    return (
        <div className="access-required-card">
            <h2>Access Required</h2>
            <h3>You do not have access to this site.</h3>
            <p></p>
            <p>Please raise a service request to gain the appropriate access.</p>
            <p><a href={accessLink}>{accessLink}</a></p>
        </div>
    );
}
